import React from "react";
import "./css/FormComponents.css";

/**
 * FormGroup Component
 * A wrapper component for form inputs that provides consistent layout and styling
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render inside the form group
 * @param {string} props.className - Additional CSS classes to apply
 * @param {boolean} props.inline - Whether the form group should be displayed inline
 * @returns {React.ReactElement} FormGroup component
 */
const FormGroup = ({ children, className = "", inline = false }) => {
  return (
    <div
      className={`form-group ${inline ? "form-group-inline" : ""} ${className}`}
    >
      {children}
    </div>
  );
};

export default FormGroup;
